/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/study-member.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { StudyMemberAuditFields } from 'queries/generated/fragments.generated';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import { getFieldChangeItems, getProcessedFieldChangeItems } from 'views/pages/admin/audit-log/service';

const StudyMemberRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
        Status: null,
        Role: null,
    };

    const refactoredNewRecord = {
        ...newRecord,
        Status: null,
        Role: null,
    };

    const lookups: any = {
        DefaultSiteId: (member: StudyMemberAuditFields) => member?.defaultSite?.name,
    };

    // Associations:
    const associations: any = {
        FavouriteSiteIds: {
            itemField: 'favouriteSites',
            name: 'Favorite Site',
            nameResolver: (site: any) => site.name,
        },
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            lookups,
            associations,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { StudyMemberRecordChangeGrid };
